import { z } from 'zod';
import { vehicleGroupsSchema } from './vehicle-group.schema';

export const customPlaceSchema = z.object({
  id: z.number(),
  name: z.string(),
  vehicleGroups: vehicleGroupsSchema,
  isDefault: z.boolean(),
});

export const customPlacesSchema = z.array(customPlaceSchema);

export type CustomPlace = z.infer<typeof customPlaceSchema>;
